import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';

const LoadingIcon = () => (
  <Box
    sx={{
      display: 'flex',
      height: '100vh',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
  >
    <LinearProgress color="primary" sx={{ width: 400, mt: 5 }} />
  </Box>
);

export default LoadingIcon;
